/*
Copyright 2022 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/
import { css } from '@spectrum-web-components/base';
const styles = css`
:host{font-weight:var(--spectrum-treeview-heading-font-weight);padding:var(--spectrum-treeview-item-padding-left) var(--spectrum-treeview-item-padding-top) var(--spectrum-treeview-item-padding-right) var(--spectrum-treeview-item-padding-bottom)}:host(:not(:first-child)){margin-top:var(
--spectrum-global-dimension-size-200
)}
`;
export default styles;